const app = {
    name: 'PCP',
    description: 'People Capacity Performance'
}

export default app
